import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { backend_domain } from "../helpers";
import { userContext } from "../context/UserContext";
import ReactHtmlParser from "react-html-parser";

const ProductCardShop = ({ product }) => {
  const { user, cartUpdate } = useContext(userContext);
  const [currentQty, setCurrentQty] = useState(
    product?.sales_order_info?.exists ? product?.sales_order_info?.qty : 0
  );
  return (
    <div className="d-flex flex-column align-items-start h-100 p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 bg-white">
      <Link
        to={`/singleProduct?id=${product?.item_code}`}
        className="product-card__thumb custom-product-card__thumb flex-center rounded-8 bg-gray-50 position-relative mb-10"
      >
        <img
          src={`${backend_domain}${product?.images[0]}`}
          alt=""
          className="w-auto max-w-content"
        />
      </Link>
      <div className="product-card__content custom-product-card__content mt-12 w-100 ms-0">
        <div>
          <h6 className="title text-lg fw-semibold mt-12 mb-8">
            <Link
              to={`/singleProduct?id=${product?.item_code}`}
              className="link text-line-2"
              tabIndex={0}
            >
              {product?.item_name}
            </Link>
          </h6>
          <p className="">
            <Link
              to={`/singleProduct?id=${product?.item_code}`}
              className="link text-line-1 text-gray-500 fw-normal"
              tabIndex={0}
            >
              {ReactHtmlParser(product?.description)}
            </Link>
          </p>

          <div className="product-card__price my-20">
            <span className="text-heading text-md fw-semibold ">
              {product?.prices[0]?.rate} KD
            </span>
          </div>
        </div>

        {user?.name == "guest" ? (
          <Link
            to="/login"
            className="product-card__cart btn bg-gray-50 text-heading hover-bg-main-600 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium"
            tabIndex={0}
          >
            Add To Cart <i className="ph ph-shopping-cart" />
          </Link>
        ) : (
          <>
            <div className="mt-24">
              {currentQty > 0 ? (
                <div className="d-flex rounded-4 overflow-hidden">
                  <button
                    type="button"
                    className="quantity__minus flex-shrink-0 h-48 w-48 text-neutral-600 bg-gray-50 flex-center hover-bg-main-600 hover-text-white"
                    onClick={() => {
                      setCurrentQty(currentQty - 1);

                      cartUpdate({
                        item_code: product?.item_code,
                        qty: currentQty - 1,
                        rate: product?.prices[0]?.rate,
                      });
                    }}
                  >
                    <i className="ph ph-minus" />
                  </button>
                  <input
                    type="number"
                    className="quantity__input flex-grow-1 border border-gray-100 border-start-0 border-end-0 text-center w-32 px-16"
                    id="stock"
                    readOnly
                    value={currentQty}
                  />
                  <button
                    type="button"
                    onClick={() => {
                      setCurrentQty(currentQty + 1);

                      cartUpdate({
                        item_code: product?.item_code,
                        qty: currentQty + 1,
                        rate: product?.prices[0]?.rate,
                      });
                    }}
                    className="quantity__plus flex-shrink-0 h-48 w-48 text-neutral-600 bg-gray-50 flex-center hover-bg-main-600 hover-text-white"
                  >
                    <i className="ph ph-plus" />
                  </button>
                </div>
              ) : (
                <button
                  onClick={() => {
                    cartUpdate({
                      item_code: product?.item_code,
                      qty: 1.0,
                      rate: product?.prices[0]?.rate,
                    });
                    setCurrentQty(1);
                  }}
                  className="product-card__cart btn bg-main-50 text-main-600 hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8 w-100 justify-content-center"
                >
                  Add <i className="ph ph-shopping-cart" />
                </button>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ProductCardShop;
